<template>
  <div class="mainContent">
    <!-- 轮播图 -->
    <el-carousel height="620px">
      <el-carousel-item
        v-for="(item, index) in slideShowList"
        :key="index"
        style="height: 620px;"
      >
        <img
          @click="toDetail1(item.id,item)"
          :src="item.coverPic"
          style="height: 100%;width: 100%;cursor: pointer"
        />
      </el-carousel-item>
    </el-carousel>
    <div class="centerDiv">
      <div class="backgroundImgDiv"></div>
      <div class="oneToThree">
        <!-- 栏位1 -- 最新动态 -->
        <div class="oneDiv">
          <div class="oneTitleDiv">
            <div class="oneTitle">
              <div class="pubTitle">
                最新动态
              </div>
              <div class="pubTitles">
                —— News
              </div>
            </div>
            <div class="oneMore" @click="toListCenter(columnData.column2)">
              <img :src="require('../assets/moreIcons.png')" alt="" />
              <span style="margin:0 4px 0 8px"> 查看更多</span>
              <img :src="require('../assets/moreIcon.png')" alt="" />
            </div>
          </div>
          <div class="oneContent">
            <div class="oneContentLeft" @click="toDetail(newsLeftData.id)">
              <img
                :src="'/mainsys/UserFiles/menupic/' + newsLeftData.picUrl"
                v-if="newsLeftData.picUrl"
                style="width:100%;height:100%"
              />
              <img v-else src="@/assets/xinwen.png" alt=""  style="width:100%;height:100%">
              <div class="oneContentLeftContent">
                <div style="color:#FFFFFF;margin-bottom:8px">
                  {{ timeToYearMonthDay(newsLeftData.addDate) }}
                </div>
                <div
                  style="font-weight: 700;font-size: 18px;color: #FFFFFF;margin-bottom:14px"
                >
                  {{ newsLeftData.title }}
                </div>
                <el-divider></el-divider>
                <div
                  style="font-size: 12px;letter-spacing:1px;line-height:18px;color: #FFFFFF;margin-top:14px;  overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;"
                >{{newsLeftData.descripton}}</div>
              </div>
            </div>
            <div class="oneContentMiddle"></div>
            <div class="oneContentRight">
              <div class="oneContentPhoto">
                <img
                  :src="require('../assets/new.png')"
                  alt=""
                  style="height:209px;width:100%"
                />
              </div>
              <div
                v-for="(item, index) in newsRightData"
                :key="index"
                class="oneContentList"
                v-on:mouseenter="onMouseEnter(index, item)"
                @click="toDetail(item.id)"
              >
                <el-divider
                  direction="vertical"
                  class="oneContentbefore"
                ></el-divider>
                <div class="oneContentListChild">
                  <div style="color:#13499B;margin-bottom:8px">
                    【 {{ timeToYearMonthDay(item.addDate) }} 】
                  </div>
                  <div class="oneContentTitle">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 栏位2和栏位3 -->
        <div class="twoToThreeDiv mt-10">
          <!-- 栏位2 -->
          <div class="twoDiv flex">
            <div class="twoMenu">
              <div
                v-for="(item, index) in columnData.column2.twoData"
                :key="index"
                @click="changeColumn(item, index)"
                class= 'flex items-center pl-6'
                :class="
                  chooseColumn2 == index ? 'twoMenuChildChoose' : 'twoMenuChild'
                "
              >
                {{ item.label }}
                <img
                  style="margin-left: 24px;margin-bottom: -1px;"
                  :src="require('../assets/choose.png')"
                  alt=""
                  v-if="chooseColumn2 == index"
                />
                <span v-else style="margin-left: 24px"></span>
              </div>
            </div>
            <div class="twoContent flex-1  flex flex-col items-center gap-8">
              <div
                v-for="(item, index) in column2Con"
                :key="index"
                class="twoContentList"
                @click="toDetail(item.id,chooseColumn2,chooseColumn2Name)"
              >
                <div class="twoContentImg">
                  <img
                    :src="'/mainsys/UserFiles/menupic/' + item.picUrl"
                    style="width:100%;height:100%;object-fit: cover"
                  />
                  <div class="twoContentDay">
                    <span
                      style="font-size: 28px;color: #FFFFFF;letter-spacing: 0;margin-bottom: -5px;margin-top: 4px;display: block;"
                    >
                      {{ timeToYearMonthDayThree(item.addDate).day }}
                    </span>
                    <span
                      style="font-size: 12px;color: #FFFFFF;letter-spacing: 0;"
                    >
                      {{ timeToYearMonthDayThree(item.addDate).year }}
                    </span>
                  </div>
                </div>
                <div class="twoContentDiv flex-1">
                  <div class="twoContentTitle">{{ item.title }}</div>
                  <div class="twoContents">{{item.descripton}}</div>
                  <div class="twoContentbefore">
                    <el-divider></el-divider>
                  </div>
                </div>
              </div>
              <el-divider></el-divider>
              <div class="twoMore flex items-center gap-1" @click="toListCenter(columnData.column2)">
                <span style="margin:0 4px 0 8px"> 查看更多</span>
                <img
                  :src="require('../assets/moreIcon.png')"
                  alt=""
                  style="width:14px;height:8px"
                />
              </div>
            </div>
          </div>
          <!-- 栏位3 -->
          <div class="threeDiv flex-1">
            <div class="threeTitleDiv">
              <div class="threeTitle">
                {{ columnData.column3.label }}
              </div>
              <div class="threeTitleBorder"></div>
            </div>
            <div class="threeContentDiv">
              <div
                class="threeContentList"
                v-for="(item, index) in columnData.column3.newData"
                :key="index"
                @click="toDetail(item.id)"
              >
                <div class="threeDayDiv">
                  <div
                    style="font-size: 22px;color: #FFFFFF;letter-spacing: 0;"
                  >
                    {{ timeToYearMonthDayThree(item.addDate).day }}
                  </div>
                  <div
                    style="font-size: 12px;color: #FFFFFF;letter-spacing: 0;"
                  >
                    {{ timeToYearMonthDayThree(item.addDate).year }}
                  </div>
                </div>
                <div class="threeContentListChild">
                  <div class="threeContentTitle">
                    {{ item.title }}
                  </div>
                  <div class="threeContent">{{item.descripton}}</div>
                </div>
              </div>
              <div class="threeMore flex items-center" @click="toList(columnData.column3.id)">
                <span style="margin:0 4px 0 8px"> 查看更多</span>
                <img
                  :src="require('../assets/moreIconWhite.png')"
                  alt=""
                  style="width:14px;height:8px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fourBgImg"></div>
      <div class="fiveBgImg"></div>
      <div class="fourBox">
        <!-- 栏位4 -->
        <div class="fourDiv">
          <div class="fourTitleDiv">
            <div class="oneTitle">
              <div class="pubTitle">
                {{ columnData.column4.label }}
              </div>
              <div class="pubTitles">—— {{ columnData.column4.englishName }}</div>
            </div>
            <div class="oneMore" @click="toList(columnData.column4.id)">
              <img :src="require('../assets/moreIcons.png')" alt="" />
              <span style="margin:0 4px 0 8px"> 查看更多</span>
              <img :src="require('../assets/moreIcon.png')" alt="" />
            </div>
          </div>
          <div class="fourContentList">
            <div
              class="fourContentChild"
              v-for="(item, index) in columnData.column4.newData"
              :key="index"
              @click="toDetail(item.id)"
            >
              <div class="fourContentImg">
                <img
                  :src="'/mainsys/UserFiles/menupic/' + item.picUrl"
                  style="width:100%;height:100%"
                />
              </div>
              <div class="fourContentDiv">
                <div class="fourContentTitle">
                  {{ item.title }}
                </div>
                <div class="fourContent">{{item.descripton}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 栏位5和外部链接 -->
        <div class="fiveToLink">
          <!-- 栏位5 -->
          <div class="fiveDiv">
            <div class="fiveTitleDiv">
              <div class="oneTitle">
                <div class="pubTitle">
                  {{ columnData.column5.label }}
                </div>
                <div class="pubTitles" style="width: 314px;">
                  —— {{ columnData.column5.englishName }}
                </div>
              </div>
              <div
                style="display:flex;align-items: center;justify-content: space-between;flex:1;margin-left:240px"
              >
                <div style="display:flex;align-items: center;">
                  <div
                    style="width: 2px;height: 54px;opacity: 0.5; background: #999999;margin-right:45px"
                  ></div>
                  <div
                    v-for="(item, index) in columnData.column5.twoData"
                    :key="index"
                    @click="changeColumn5(item, index)"
                    :class="
                    chooseColumn5 == index ? 'fiveChooseMenu' : 'fiveMenu'
                  "
                  >
                    {{ item.label }}
                  </div>
                </div>
                <div class="oneMore" @click="toListTeach(columnData.column5.id)">
                  <img :src="require('../assets/moreIcons.png')" alt="" />
                  <span style="margin:0 4px 0 8px"> 查看更多</span>
                  <img :src="require('../assets/moreIcon.png')" alt="" />
                </div>
              </div>
            </div>
            <div class="fiveContentList">
              <div
                class="fiveContentChild"
                v-for="(item, index) in column5Con"
                :key="index"
                @click="toDetail(item.id,chooseColumn5)"
              >
                <div class="fiveContentImg">
                  <img
                    :src="'/mainsys/UserFiles/menupic/' + item.picUrl"
                    style="width:100%;height:240px;object-fit: cover"
                  />
                </div>
                <div class="fiveContentDiv">
                  <div
                    :class="
                    item.descripton.includes('省级一流')
                      ? 'fiveContentTitless'
                      : 'fiveContentTitle'
                  "
                  >
                    <!-- <div
                      :class="
                        item.descripton.includes('省级一流')
                          ? 'fiveContentDess'
                          : 'fiveContentDes'
                      "
                    >
                      {{ item.descripton }}
                    </div> -->
                    <div class="fiveContentTitles">
                      {{ item.title }}
                    </div>
                  </div>
                  <div class="fiveContent">{{item.descripton}}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 链接 -->
          <div class="linkOut">
            <div class="linkTitleDiv">
              <div class="linkTitle">
                <div class="pubLinkTitle">
                  资源平台
                </div>
                <div class="pubTitles">
                  —— Resource platform ——
                </div>
              </div>
            </div>
            <div class="fiveContentList1">
              <div
                class="linkContentChild"
                v-for="(item, index) in friendshipLink.outer"
                :key="index"
                @click="goLink(item)"
              >
                <div style="height: 50px;width: 50px;margin-right:20px">
                  <img
                    :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
                    style="height: 50px;width: 50px"
                  />
                </div>
                <div>
                  <div class="fourContentTitle" style="text-align: center">
                    {{ item.linkName }}
                  </div>
                  <div class="linkContent">{{ item.linkDescription }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <!-- 底部快捷链接 -->
        <div class="bottomLink">
          <div style="
            margin: 0 auto;display: flex;
            align-items: center;
            justify-content: center;
            width: 1300px;
            padding: 0 5%;
            height: 60px;
">
            <div
              v-for="(item, index) in friendshipLink.res"
              :key="index"
              class="bottomLinkList"
              :style="{cursor:item.linkName == '中心服务'?'default':'pointer'}"
              @click="goLink(item)"
            >
              <div style="display:flex;align-items: center;">
                <img
                  :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
                  style="height: 18px;width: 18px;margin-right:12px;"
                />
                <div style="line-height: 20px;height: 20px;">
                  {{ item.linkName }}
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- 底部版权信息 -->
        <div class="copyDiv">
          <div style="width: 1300px;margin: 0 auto;display: flex;
          justify-content: space-between;
          align-items: center;">
            <div class="copyDivLeft">
              <img
                :src="require('../assets/bottomLogo.png')"
                alt=""
                style="width:360px;height:50px;margin-bottom:16px"
              />
              <div class="copyDivLeftCon">建设单位：国防科技大学</div>
              <div class="copyDivLeftCon">支持单位：湖南强智科技发展有限公司</div>
              <div class="copyDivLeftCon">
                推荐使用: Chrome或Firefox等主流浏览器
              </div>
              <div class="copyDivLeftCon">
                Copyright © 1999- 2024 国防科技大学 版权所有
              </div>
              <div class="copyDivLeftCon">
                网站访问次数：{{websiteVisitsNum}} 次
              </div>
            </div>
            <div
              class="copyDivRight"
              style="text-align:center;width: 200px"
              v-if="friendshipLink.top && friendshipLink.top.length > 0"
            >
              <img
                :src="
              '/mainsys/UserFiles/externalicon/' +
                friendshipLink.top[0].linkImage
            "
                alt=""
                style="width:140px;height:140px;margin:0 auto;text-align: center"
              />
              <div style="font-size: 16px;color: #FAFAFA;margin-top: 16px">
                {{ friendshipLink.top[0].linkName }}
              </div>
            </div>
          </div>

        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slideShowList: [], //轮播图的数组
      columnData: {
        column1: {},
        column2: {},
        column3: {},
        column4: {},
        column5: {}
      },
      loginStatus: 1, //1-未登录 2-已登录
      newsLeftData: {},
      newsRightData:[],
      chooseColumn2: 0,
      chooseColumn2Name:'',
      column2Con: [],
      chooseColumn5: 0,
      column5Con: [],
      websiteVisitsNum:0,
      top:0,
    };
  },
  methods: {
    onMouseEnter(index, item) {
      this.newsLeftData = item;
      console.log("Div is hovered!", index, item);
    },
    timeToYearMonthDay(time) {
      var newTime = new Date(time);
      var year = newTime.getFullYear();
      var month = newTime.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var date = newTime.getDate();
      date = date < 10 ? "0" + date : date;
      return year + "年" + month + "月" + date + "日";
    },
    timeToYearMonthDayThree(time) {
      var newTime = new Date(time);
      var year = newTime.getFullYear();
      var month = newTime.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var date = newTime.getDate();
      date = date < 10 ? "0" + date : date;
      let datas = {
        year: year + "." + month,
        day: date
      };
      return datas;
    },
    changeColumn(item, index) {
      console.log(item,'dsads')
      this.column2Con = item.data;
      this.chooseColumn2 = index;
      this.chooseColumn2Name = item.label
    },
    changeColumn5(item, index) {
      this.column5Con = item.data;
      this.chooseColumn5 = index;
    },
    toListCenter(item) {
      console.log(item,'iter')
      if(item.twoData&&item.twoData.length>0){
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: item.twoData[0].id },
        });
      }

    },
    toListTeach(menuId) {
      let id =""
      if(this.columnData.column5.twoData && this.columnData.column5.twoData.length>0){
        id = this.columnData.column5.twoData[0].id
      }else{
        id = menuId
      }
      this.$router.push({
        path: "ListTeach:menuId",
        name: "ListTeach",
        params: { menuId: id },
      });
    },
    toList(menuId) {
      this.$router.push({
        path: "List:menuId",
        name: "List",
        params: { menuId: menuId }
      });
    },
    getSlideShow() {
      //获取轮播图
      axios.post("/cmsapi/getSlideshow").then(response => {
        let recData = response.data;
        this.slideShowList = recData;
        if (this.slideShowList.length > 0) {
          for (var i = 0; i < this.slideShowList.length; i++) {
            this.slideShowList[i].coverPic =
              "/mainsys/UserFiles/coverpic/" + this.slideShowList[i].coverPic;
          }
        } else {
          this.slideShowList = [
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            }
          ];
        }
      });
    },
    toDetail(contentId,index,name) {
      // localStorage.setItem('isRefresh','1')
      this.$router.push({
        name: "Detail",
        params: { contentId: contentId,activeIndex:index,activeName:name }
      });
    },
    toDetail1(contentId,item){
      console.log(item)
      if(item.description){
        localStorage.setItem('isRefresh','1')
        this.$router.push({
          name: "Detail",
          params: { contentId: contentId,activeIndex:null }
        });
      }
    },
    goLink(item) {
      if(item.linkName=='头歌'){
        this.$router.push({
          path: "/touGe",
          query:{
            url:item.linkUrl
          }
          // params: { contentId: item.id,activeIndex:null }
        });
      }else{
        if (item.linkUrl != "/") {
          if (item.linkTarget == "_blank") {
            window.open(item.linkUrl);
          } else {
            window.location.href = item.linkUrl;
          }
        }
      }

    },
    dateData(property, bol) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (bol) {
          // 升序
          return Date.parse(value1) - Date.parse(value2);
        } else {
          // 降序
          return Date.parse(value2) - Date.parse(value1);
        }
      };
    },
    getList() {
      axios
        .post("/cmsapi/getIndexNews", {})
        .then(response => {

          let result = response.data.rootData[0].oneData;
          console.log(result,'result?????????')
          if (result && result.length > 0) {
            result.forEach(item => {
              if (item.boxcode == "1") {
                this.columnData.column1 = item;
                if (item.newData && item.newData.length > 0) {
                  this.newsLeftData = item.newData[0];
                  item.newData =
                    item.newData.length > 3
                      ? item.newData.splice(0, 3)
                      : item.newData;
                }
              } else if (item.boxcode == "2") {
                this.columnData.column2 = item;
                if (item.twoData && item.twoData.length > 0) {
                  let data = [];
                  item.twoData.forEach(val => {
                    if (val.data && val.data.length > 0) {
                      val.data =
                        val.data.length > 4 ? val.data.splice(0, 4) : val.data;
                    }
                    if (val.data && val.data.length > 0) {
                      data.push(...val.data);
                    }
                  });
                  if (data.length > 0) {
                    data.sort(this.dateData("addDate", false));
                    this.newsLeftData = data[0];
                    this.newsRightData =
                      data.length > 3 ? data.splice(0, 3) : data;
                  }
                  this.column2Con = item.twoData[0].data;
                }
              } else if (item.boxcode == "3") {
                this.columnData.column3 = item;
                if (item.newData && item.newData.length > 0) {
                  item.newData =
                    item.newData.length > 4
                      ? item.newData.splice(0, 4)
                      : item.newData;
                }
              } else if (item.boxcode == "4") {
                this.columnData.column4 = item;
                if (item.newData && item.newData.length > 0) {
                  item.newData =
                    item.newData.length > 6
                      ? item.newData.splice(0, 6)
                      : item.newData;
                }
              } else if (item.boxcode == "5") {
                this.columnData.column5 = item;
                if (item.twoData && item.twoData.length > 0) {
                  item.twoData.forEach(val => {
                    if (val.data && val.data.length > 0) {
                      val.data =
                        val.data.length > 3 ? val.data.splice(0, 3) : val.data;
                    }
                  });
                  this.column5Con = item.twoData[0].data;
                }
              }
            });
          }
          console.log(this.newsLeftData,'newsLeftData')
          console.log("this.columnData", this.columnData);
        })
        .catch(error => {
          console.log(error);
          // this.$message.error('网络出现问题，请检查网络！');
        });
    },
    getListNo() {
      axios
        .post("/cmsapi/getNotLogIn", {})
        .then(response => {
          let result = response.data.rootData[0].oneData;
          if (result && result.length > 0) {
            result.forEach(item => {
              if (item.boxcode == "1") {
                this.columnData.column1 = item;
                if (item.newData && item.newData.length > 0) {
                  this.newsLeftData = item.newData[0];
                  item.newData =
                    item.newData.length > 3
                      ? item.newData.splice(0, 3)
                      : item.newData;
                }
              } else if (item.boxcode == "2") {
                this.columnData.column2 = item;
                if (item.twoData && item.twoData.length > 0) {
                  let data = [];
                  item.twoData.forEach(val => {
                    if (val.data && val.data.length > 0) {
                      val.data =
                        val.data.length > 4 ? val.data.splice(0, 4) : val.data;
                    }
                    if (val.data && val.data.length > 0) {
                      data.push(...val.data);
                    }
                  });
                  if (data.length > 0) {
                    data.sort(this.dateData("addDate", false));
                    this.newsLeftData = data[0];
                    this.newsRightData =
                      data.length > 3 ? data.splice(0, 3) : data;
                  }
                  this.column2Con = item.twoData[0].data;
                }
              } else if (item.boxcode == "3") {
                this.columnData.column3 = item;
                if (item.newData && item.newData.length > 0) {
                  item.newData =
                    item.newData.length > 4
                      ? item.newData.splice(0, 4)
                      : item.newData;
                }
              } else if (item.boxcode == "4") {
                this.columnData.column4 = item;
                if (item.newData && item.newData.length > 0) {
                  item.newData =
                    item.newData.length > 6
                      ? item.newData.splice(0, 6)
                      : item.newData;
                }
              } else if (item.boxcode == "5") {
                this.columnData.column5 = item;
                if (item.twoData && item.twoData.length > 0) {
                  item.twoData.forEach(val => {
                    if (val.data && val.data.length > 0) {
                      val.data =
                        val.data.length > 3 ? val.data.splice(0, 3) : val.data;
                    }
                  });
                  this.column5Con = item.twoData[0].data;
                }
              }
            });
          }
          console.log("this.columnData", this.columnData);
        })
        .catch(error => {
          console.log(error);
          // this.$message.error('网络出现问题，请检查网络！');
        });
    },
    getAccessLogNum(){
     axios
      .post("/cmsapi/getAccessLogNum").then((res)=>{
        if(res.data.code == '2'){
          this.websiteVisitsNum = res.data.data
        }
      })
    },

  },
  created() {
    console.log(this.friendshipLink)
    //获取当前用户登录状态
    axios
      .post("/getUserLoginInfo")
      .then(response => {
        let data = response.data; //数据
        if (data.code > 0) {
          this.loginStatus = data.code;
          sessionStorage.setItem("loginStatus", data.code);
          if (data.data) {
            sessionStorage.setItem("schType", data.data.schType);
            sessionStorage.setItem("userId", data.data.userId);
            if (data.code == 2) this.userInfo = data.data;
          }
          this.getList();
          // console.log(this.loginStatus, "this.loginStatus");
          // if (this.loginStatus == "2") {
          //   this.getList();
          // } else {
          //   console.log(2222222222222);
          //   this.getListNo();
          // }
        }
      })
      .catch(error => {
        console.error(error);
      });

    this.getSlideShow();
    this.getAccessLogNum()
  },
  mounted() {

  },
  beforeDestroy() {
    // 在组件销毁前清除定时器，以防止内存泄漏
    clearTimeout(this.timer);
  }
};
</script>

<style scoped >
.mainContent {
  height: calc(100% - 170px);
  width: 100%;
}
.mainContent >>> .el-carousel__indicators--horizontal {
  bottom: 15px !important;
  left: 20% !important;
}
.centerDiv {
  position: relative;
  /* padding: 0 260px;
  width: calc(100% - 520px); */
  width: 100%;
  height: auto;
}
.backgroundImgDiv{
  position: absolute;
  width: 100%;
  background-size: 100% auto;
  background: url("../assets/bg1.png") no-repeat center;
  z-index: -99;
  height: 750px;
  top: 500px;
}
.oneToThree {
  height: 1750px;
  /* min-height: 1000px; */
  width: 1300px;
  margin: 0 auto;
}
.fourBox{
  width: 1300px;
  margin: 0 auto;
  position: relative;
}
.oneDiv {
  height: 713px;
  padding: 68px 5% 0 5%;
  z-index: 999;
  /* width: calc(100% - 520px); */
  /* background-color: red; */
  /* border-bottom: 2px solid red; */
}
.oneTitleDiv {
  height: 70px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  position: relative;
}
.oneTitle {
  height: 100%;
  width: 217px;
  padding-top: 6px;
  background: url("../assets/title.png") no-repeat;
  position: absolute;
  left: -65px;
}
.pubTitle {
  font-weight: 700;
  font-size: 34px;
  color: #13499b;
  letter-spacing: 4px;
  text-align: end;
}
.pubTitles {
  color: #13499b;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}
.oneMore {
  font-size: 16px;
  color: #13499b;
  height: 30px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
  right: 0;
}

.oneContent {
  width: 100%;
  height: 532px;
  /* background-color: red; */
  display: flex;
}
.oneContentLeft {
  height: 100%;
  width: 70%;
  position: relative;
  cursor: pointer;
  /* background: url("../assets/news.png") no-repeat;
  background-size: 100% 100%; */
  /* background-size: contain; */
}
.oneContentLeftContent {
  height: 153px;
  position: absolute;
  width:100%;
  /* background-color: red; */
  left: 0;
  bottom: 0;
  padding: 16px 32px;
  /* backdrop-filter: blur(2px); */
  background-color:rgba(14, 13, 13, 0.3);
}
.oneContentMiddle {
  height: 100%;
  width: 1px;
  background-color: #d5d5d5;
  margin-left: 30px;
}
.oneContentRight {
  height: 100%;
  flex: 1;
}
.oneContentPhoto {
  padding: 0 0 0 30px;
}
.oneContentList {
  height: 106px;
  width: 100%;
  cursor: pointer;
  display: block;
  position: relative;
}
.oneContentList:hover .oneContentbefore {
  display: block;
}

.oneContentListChild {
  /* width: calc(100% - 30px); */
  height: 104px;
  padding: 16px 0 16px 0px;
  margin-left: 30px;
  border-bottom: 1px dashed #dbdbdb;
}
.oneContentTitle {
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.oneContentTitle:hover {
  color: #13499b;
}
.oneContentbefore {
  position: absolute;
  display: none;
}
.el-divider--vertical {
  margin: 0px !important;
  background-color: #13499b !important;
  height: 64px !important;
  width: 3px !important;
  top: 20px !important;
  left: -1.5px;
}
.el-divider--horizontal {
  margin: 0px !important;
  background-color: #d6d6d6 !important;
}
.twoToThreeDiv {
  height: 932px;
  padding: 0 5% 40px 5%;
  z-index: 999;
  /* width: calc(100% - 520px); */
  /* background-color: red; */
  display: flex;
  /* border-bottom: 2px solid red; */
}
.twoDiv {
  height: 100%;
  width: 70%;
  /* background: red; */
}
.threeDiv {
  height: 100%;
  margin-left: 30px;
  background: #13499b;
}
.threeTitleDiv {
  height: 91px;
  line-height: 91px;
  width: 100%;
  background: url("../assets/titleThree.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.threeTitle {
  font-weight: 700;
  font-size: 28px;
  color: #ffffff;
  letter-spacing: 0;
  margin-left: 8px;
}
.threeTitleBorder {
  height: 2px;
  width: 108px;
  background-color: #ffffff;
  position: absolute;
  bottom: 0px;
  left: 26px;
}
.threeContentDiv {
  height: 800px;
  width: 100%;
  position: relative;
}
.threeContentList {
  /* width: calc(100% - 60px); */
  width: 100%;
  position: relative;
  padding: 26px 30px 20px 30px;
  height: 190px;
  display: flex;
  cursor: pointer;
  /* background-color: aquamarine; */
}
.threeContentList:hover {
  background-color: #2b5ba5;
}
.threeContentList:after {
  position: absolute;
  bottom: 0;
  left: 106px;
  right: 0px;
  height: 1px;
  content: "";
  /* -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5); */
  background-color: #fff;
  opacity: 0.2;
}
.threeDayDiv {
  height: 45px;
  width: 45px;
  margin-right: 30px;
  text-align: center;
}
.threeContentListChild {
  /* flex: 1; */
  /* width: calc(100% - 75px); */
}
.threeContentTitle {
  font-weight: 700;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-bottom: 8px;
}
.threeContent {
  opacity: 0.6;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-height: 24px;
}
.threeMore {
  font-size: 16px;
  color: #ffffff;
  position: absolute;
  bottom: 6px;
  right: 28px;
  cursor: pointer;
}
.twoMore {
  font-size: 16px;
  color: #13499b;
  position: absolute;
  bottom: 10px;
  right: 0px;
  cursor: pointer;
}
.twoMenu {
  width: 140px;
  height: auto;
  background-color: #fff;
  border-left: 4px solid #13499b;
  float: left;
  margin-right: 68px;
}
.twoMenuChild {
  height: 58px;
  width: 140px;
  line-height: 58px;
  text-align: center;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  cursor: pointer;
  /* padding-right: 24px; */
}
.twoMenuChild:hover {
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  background: #13499b;
  width: 140px;
  cursor: pointer;
}
.twoMenuChildChoose {
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  background: #13499b;
  width: 155px;
  cursor: pointer;
}
.twoContent {
  /* width: calc(100% - 212px); */
  height: 100%;
  /* background-color: red; */
  float: left;
  position: relative;
}
.twoContentList {
  /* border-bottom: 1px solid red; */
  height: 219px;
  width: 100%;
  display: flex;
}
.twoContentImg {
  height: 183px;
  width: 300px;
  position: relative;
}
.twoContentDay {
  position: absolute;
  left: -17px;
  bottom: 17px;
  width: 62px;
  height: 62px;
  background: #d3b17d;
  text-align: center;
}
.twoContentDiv {
  height: 183px;
  /* width: calc(100% - 300px); */
  /* background-color: red; */
  padding-left: 32px;
  padding-top: 16px;
  width: 322px;
  position: relative;
  cursor: pointer;
}
.twoContentDiv:hover .twoContentTitle {
  color: #13499b;
}
.twoContentDiv:hover .twoContentbefore {
  display: block;
}
.twoContentbefore {
  position: absolute;
  bottom: 0;
  display: none;
}
.twoContentbefore >>> .el-divider--horizontal {
  margin: 0px !important;
  width: 60px !important;
  height: 2px !important;
  background-color: #13499b !important;
}
.twoContentTitle {
  font-weight: 700;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-bottom: 8px;
}
.twoContents {
  opacity: 0.6;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-height: 24px;
}
.fourDiv {
  height: 970px;
  padding: 30px 5% 0 5%;
  /* width: calc(100% - 520px); */
  //background: url("../assets/bg2.png") no-repeat;
  //background-size: 100% 100%;
}
.fourBgImg{
  position: absolute;
  width: 100%;
  background-size: 100% auto;
  background: url("../assets/bg2.png") no-repeat center;
  z-index: -99;
  height: 970px;
  top: 1850px;
}
.fourTitleDiv {
  height: 70px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  position: relative;
}
.fourContentList {
  width: 100%;
  /* height: calc(100% - 110px); */
  display: flex;
  flex-wrap: wrap;
  align-content: baseline;
  justify-content: start;
}
.fourContentChild {
  height: 382px;
  /* width: 435px; */
  width: 32%;
  /* margin-right: 37px; */
  /* border: 1px solid #13499b; */
  background: #fff;
  margin-bottom: 35px;
  margin-right: 1%;
  cursor: pointer;
  box-sizing: border-box;
}
.fourContentChild:hover {
  border-bottom: 4px solid #13499b;
}
.fourContentImg {
  height: 268px;
  width: 100%;
}
.fourContentDiv {
  padding: 18px 20px;
}
.fourContentTitle {
  font-weight: 700;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  margin-bottom: 8px;
}
.fourContent {
  opacity: 0.6;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 22px;
}
.fourContentChild:hover .fourContentTitle {
  color: #13499b;
}
.fiveBgImg{
  position: absolute;
  width: 100%;
  background-size: 100% auto;
  background: url("../assets/bg3.png") no-repeat bottom;
  z-index: -99;
  height: 962px;
  top: 2400px;
}
.fiveToLink {
  min-height: 962px;
  padding: 58px 5% 0 5%;
  width: 100%;
}
.fiveDiv {
  height: 624px;
  width: 100%;
}
.fiveTitleDiv {
  height: 70px;
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  margin-bottom: 40px;
  position: relative;
}
.fiveContentList {
  width: 100%;
  /* height: calc(100% - 110px); */
  display: flex;
  flex-wrap: wrap;
  align-content: baseline;
  justify-content: start;
}
.fiveContentList1 {
  width: 100%;
  /* height: calc(100% - 110px); */
  display: flex;
  flex-wrap: wrap;
  align-content: baseline;
  justify-content: space-between;
}
.fiveContentChild {
  height: 387px;
  /* width: 435px; */
  width: 32%;
  background: #fff;
  cursor: pointer;
  box-sizing: border-box;
  margin-right: 1%;
}
.fiveContentChild:nth-child(3n+1){
  margin-left: 0;
}

.fiveContentImg {
  height: 240px;
  width: 100%;
}
.fiveContentTitle {
  margin-bottom: 12px;
  border-left: 2px solid #13499b;
}
.fiveContentTitless {
  margin-bottom: 12px;
  border-left: 2px solid #bb7915;
}
.fiveContentDes {
  margin-left: 20px;
  font-size: 12px;
  margin-bottom: 8px;
  color: #13499b;
  height: 20px;
  width: 100%;
  white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
}
.fiveContentDess {
  margin-left: 20px;
  font-size: 12px;
  margin-bottom: 8px;
  color: #bb7915;
    height: 20px;
  width: 100%;
  white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
}
.fiveContentTitles {
  font-weight: 700;
  margin-left: 20px;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.fiveContent {
  font-size: 16px;
  margin-left: 20px;
  color: #666666;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 30px;
}
.fiveContentDiv {
  padding: 24px 30px;
  /* width: calc(100% - 61px); */
  border-bottom: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  height: 147px;
}
/* .fiveContentChild:hover .fiveContentDiv {
  background-color:#13499b;
} */
.fiveContentChild:hover {
  background: url("../assets/teach.png") no-repeat;
  background-size: 174px 80px;
  background-position: bottom right;
  z-index: 999999;
  background-color: #13499b;
}
.fiveContentChild:hover .fiveContent {
  opacity: 0.8;
  color: #fff;
}
.fiveContentChild:hover .fiveContentTitles {
  color: #fff;
}
.fiveContentChild:hover .fiveContentDes {
  color: #fff;
}
.fiveContentChild:hover .fiveContentDess {
  color: #fff;
}
.fiveContentChild:hover .fiveContentTitle {
  border-left: 2px solid #fff;
}
.fiveContentChild:hover .fiveContentTitless {
  border-left: 2px solid #fff;
}
.fiveMenu {
  font-size: 16px;
  color: #666666;
  letter-spacing: 0;
  padding: 8px 0;
  cursor: pointer;
  margin-right: 45px;
}
.fiveChooseMenu {
  font-weight: 700;
  font-size: 18px;
  color: #13499b;
  letter-spacing: 0;
  padding: 8px 0;
  border-bottom: 2px solid #13499b;
  cursor: pointer;
  margin-right: 45px;
}
.fiveMenu:hover {
  color: #13499b;
  font-weight: 700;
  font-size: 18px;
  border-bottom: 2px solid #13499b;
}
.linkOut {
  min-height: 280px;
  width: 100%;
  /* background: red; */
}
.linkTitleDiv {
  height: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}
.linkTitle {
  height: 100%;
  text-align: center;
  /* width: 217px; */
  padding-top: 16px;
  background: url("../assets/title.png") no-repeat;
  background-position: center;
}
.pubLinkTitle {
  font-weight: 700;
  font-size: 34px;
  color: #13499b;
  letter-spacing: 4px;
  text-align: center;
}
.pubTitles {
  color: #13499b;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}
.linkContentChild {
  height: 90px;
  /* width: 315px; */
  width: 31%;
  background: #fff;
  cursor: pointer;
  box-sizing: border-box;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
}
.linkContent {
  opacity: 0.6;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.linkContentChild:hover {
  border-bottom: 2px solid #13499b;
}
.bottomLink {
  height: 60px;
  /* width: calc(100% - 520px); */
  background: #0d3b80;
  color: #fff;

  //display: flex;
  //align-items: center;
  //justify-content: center;
}
.bottomLinkList {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  position: relative;
  }
.bottomLinkList:not(:last-child)::after {
  content: "";
  width: 1px;
  height: 24px;
  opacity: 0.2;
  background-color: #fff;
  position: absolute;
  right: 0;
}
.linkDivider >>> .el-divider--vertical {
  height: 24px !important;
  background-color: #3f6bae !important;
  width: 1.5px !important;
  margin: 0 30px 36px 30px !important;
}
.copyDiv {
  height: 300px;
  /* width: calc(100% - 520px); */
  padding: 45px 5%;
  background: url("../assets/bottomBg.jpg") no-repeat;
  background-size: 100% 100%;

}
.copyDivLeftCon {
  opacity: 0.8;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  margin-top: 16px;
}
.el-carousel__item {
  //background-color: #99a9bf;
  background: url("../assets/lbbanner.jpg") no-repeat !important;
  background-size: 100% 100% !important;
  //z-index: 999;
}
</style>
